import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MissionValues.css';

function MissionValues() {
    return (
        <section className="mission-values py-5 bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5 mx-3 card fixed-dimension no-rounded-corners bg-primary text-dark p-4 mb-4">
                        <div className="mission-top mb-4">
                            <h2>Our Mission</h2>
                            <p>To empower businesses by providing innovative and efficient HR solutions that streamline processes, enhance employee satisfaction, and foster organizational growth.</p>
                        </div>
                        <div className="mission-bottom">
                            <h2>Our Vision</h2>
                            <p>To be the leading provider of HR solutions, known for our expertise, reliability, and commitment to client success.</p>
                        </div>
                    </div>
                    <div className="col-md-5 mx-3 card fixed-dimension no-rounded-corners bg-primary text-dark p-4">
                        <h2>Our Values</h2>
                        <ul className="list-styled">
                            <li>Integrity: We uphold the highest standards of integrity in all our actions.</li>
                            <li>Innovation: We continuously seek innovative ways to improve our services and solutions.</li>
                            <li>Customer Focus: We are dedicated to meeting and exceeding the expectations of our clients.</li>
                            <li>Excellence: We strive for excellence in everything we do.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MissionValues;
